import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// pt-BR
import ptBRCommon from "./locales/pt-BR/common.json";
import ptBRHome from "./locales/pt-BR/home.json";
import ptBRServices from "./locales/pt-BR/services.json";
import ptBRPackages from "./locales/pt-BR/packages.json";
import ptBRStats from "./locales/pt-BR/stats.json";
import ptBRAbout from "./locales/pt-BR/about.json";
import ptBRComparison from "./locales/pt-BR/comparison.json";
import ptBRWork from "./locales/pt-BR/work.json";
import ptBRCta from "./locales/pt-BR/cta.json";
import ptBRContact from "./locales/pt-BR/contact.json";
import ptBRQuickContact from "./locales/pt-BR/quickContact.json";
import ptBRContactsPage from "./locales/pt-BR/contactsPage.json";
import ptBRFaq from "./locales/pt-BR/faq.json";
import ptBRFooter from "./locales/pt-BR/footer.json";
import ptBRCookies from "./locales/pt-BR/cookies.json";
import ptBRNotFound from "./locales/pt-BR/notFound.json";
import ptBRPrivacy from "./locales/pt-BR/privacy.json";
import ptBRTerms from "./locales/pt-BR/terms.json";

// en
import enCommon from "./locales/en/common.json";
import enHome from "./locales/en/home.json";
import enServices from "./locales/en/services.json";
import enPackages from "./locales/en/packages.json";
import enStats from "./locales/en/stats.json";
import enAbout from "./locales/en/about.json";
import enComparison from "./locales/en/comparison.json";
import enWork from "./locales/en/work.json";
import enCta from "./locales/en/cta.json";
import enContact from "./locales/en/contact.json";
import enQuickContact from "./locales/en/quickContact.json";
import enContactsPage from "./locales/en/contactsPage.json";
import enFaq from "./locales/en/faq.json";
import enFooter from "./locales/en/footer.json";
import enCookies from "./locales/en/cookies.json";
import enNotFound from "./locales/en/notFound.json";
import enPrivacy from "./locales/en/privacy.json";
import enTerms from "./locales/en/terms.json";

// es
import esCommon from "./locales/es/common.json";
import esHome from "./locales/es/home.json";
import esServices from "./locales/es/services.json";
import esPackages from "./locales/es/packages.json";
import esStats from "./locales/es/stats.json";
import esAbout from "./locales/es/about.json";
import esComparison from "./locales/es/comparison.json";
import esWork from "./locales/es/work.json";
import esCta from "./locales/es/cta.json";
import esContact from "./locales/es/contact.json";
import esQuickContact from "./locales/es/quickContact.json";
import esContactsPage from "./locales/es/contactsPage.json";
import esFaq from "./locales/es/faq.json";
import esFooter from "./locales/es/footer.json";
import esCookies from "./locales/es/cookies.json";
import esNotFound from "./locales/es/notFound.json";
import esPrivacy from "./locales/es/privacy.json";
import esTerms from "./locales/es/terms.json";

// fr
import frCommon from "./locales/fr/common.json";
import frHome from "./locales/fr/home.json";
import frServices from "./locales/fr/services.json";
import frPackages from "./locales/fr/packages.json";
import frStats from "./locales/fr/stats.json";
import frAbout from "./locales/fr/about.json";
import frComparison from "./locales/fr/comparison.json";
import frWork from "./locales/fr/work.json";
import frCta from "./locales/fr/cta.json";
import frContact from "./locales/fr/contact.json";
import frQuickContact from "./locales/fr/quickContact.json";
import frContactsPage from "./locales/fr/contactsPage.json";
import frFaq from "./locales/fr/faq.json";
import frFooter from "./locales/fr/footer.json";
import frCookies from "./locales/fr/cookies.json";
import frNotFound from "./locales/fr/notFound.json";
import frPrivacy from "./locales/fr/privacy.json";
import frTerms from "./locales/fr/terms.json";

const buildNS = (common, home, services, packages, stats, about, comparison, work, cta, contact, quickContact, contactsPage, faq, footer, cookies, notFound, privacy, terms) => ({
  common, home, services, packages, stats, about, comparison, work, cta, contact, quickContact, contactsPage, faq, footer, cookies, notFound, privacy, terms,
});

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      "pt-BR": buildNS(ptBRCommon, ptBRHome, ptBRServices, ptBRPackages, ptBRStats, ptBRAbout, ptBRComparison, ptBRWork, ptBRCta, ptBRContact, ptBRQuickContact, ptBRContactsPage, ptBRFaq, ptBRFooter, ptBRCookies, ptBRNotFound, ptBRPrivacy, ptBRTerms),
      en: buildNS(enCommon, enHome, enServices, enPackages, enStats, enAbout, enComparison, enWork, enCta, enContact, enQuickContact, enContactsPage, enFaq, enFooter, enCookies, enNotFound, enPrivacy, enTerms),
      es: buildNS(esCommon, esHome, esServices, esPackages, esStats, esAbout, esComparison, esWork, esCta, esContact, esQuickContact, esContactsPage, esFaq, esFooter, esCookies, esNotFound, esPrivacy, esTerms),
      fr: buildNS(frCommon, frHome, frServices, frPackages, frStats, frAbout, frComparison, frWork, frCta, frContact, frQuickContact, frContactsPage, frFaq, frFooter, frCookies, frNotFound, frPrivacy, frTerms),
    },
    fallbackLng: "pt-BR",
    defaultNS: "common",
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "cmLang",
      caches: ["localStorage"],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
